module.exports = __webpack_public_path__ + "static/media/shufersal_big.6642db08.jpeg";